module.exports = __webpack_public_path__ + "img/product-advantage3.d07471d6.svg";